import { JsonObject, JsonProperty } from 'json2typescript';
import { Configuration } from '../configuration.model';

@JsonObject('ConfigurationsResultsResponse')
export class ConfigurationsResultsResponse {

  @JsonProperty('global_results', [Configuration])
  globalResults: Configuration[] = [];

  @JsonProperty('application_results', [Configuration])
  applicationResults: Configuration[] = [];
}
